import { render, staticRenderFns } from "./LabelSlot.vue?vue&type=template&id=50483c94"
import script from "./LabelSlot.vue?vue&type=script&lang=ts"
export * from "./LabelSlot.vue?vue&type=script&lang=ts"
import style0 from "./LabelSlot.vue?vue&type=style&index=0&id=50483c94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports